<sim-base-chip-input
	[formState]="formState"
	[label]="label ?? T.SIM_TAGS_CHIP_INPUT_LABEL | translate"
	[placeholder]="placeholder ?? T.SIM_TAGS_CHIP_INPUT_PLACEHOLDER | translate"
	[autoCompleteValues]="autoCompleteData"
	[isMultiSelect]="true"
	[isAutofocusEnabled]="false"
	(createNewItemClicked)="openCreateNewTagDialog()"
	(optionCleared)="isEditMode ? optionClearedRemoveTag($event) : optionCleared.emit($event)"
	(optionSelected)="isEditMode ? optionSelectedAddTagToTaggable($event) : optionSelected.emit($event)"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	[canAddNewItem]="isEditMode"
	[isDisabled]="disabled"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>

	<mat-icon detailButtonContent inline fontSet="fad" fontIcon="fa-th" />
</sim-base-chip-input>
